var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_3_365)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6528 10.411C24.6843 10.411 26.1276 10.8549 26.9829 11.7428C27.6244 12.4176 27.9452 13.2699 27.9452 14.2998C27.9452 14.655 27.9096 15.0279 27.8383 15.4186L27.4641 17.4962C27.2502 18.6504 26.876 19.5827 26.3414 20.293C25.8247 21.0033 25.2456 21.5094 24.6041 21.8113L27.0364 29.589H21.6371L19.3919 22.4239H17.7347L16.6388 29.589H11.5068L14.9014 10.411H22.6528ZM20.9689 14.5662H18.9642L18.2693 19.2009H20.1403C21.0847 19.2009 21.7619 18.9789 22.1717 18.535C22.5816 18.0733 22.7865 17.4696 22.7865 16.7237C22.7865 15.2854 22.1806 14.5662 20.9689 14.5662Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_365",
    x1: 5,
    y1: 48.4091,
    x2: 40,
    y2: -10.5682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6673EC",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAFAF6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a0c5e43c285906c351f2cde5919c195.svg";
export { ForwardRef as ReactComponent };